import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation } from "react-query";
import { BACKEND_DOMAIN } from "utils/constants";
import { showMutationAlert } from "utils/helpers";

const BULK_EQUIPMENT_UPLOAD_URL = `${BACKEND_DOMAIN}/sandbox/bulk-equipment-upload`;

interface Options {
    // The onSuccess is used to update the store for the progress banner
    onSuccess?: (data: { batch_id: string; queued: number }) => void;
}

const useSubmitBulkEquipmentSurveyCsvMutation = ({ onSuccess }: Options = {}) => {
    const alert = useAlert();
    const accessToken = useAccessToken();

    return useMutation({
        mutationFn: async (file: File): Promise<{ batch_id: string; queued: number }> => {
            const formData = new FormData();
            formData.append("file", file);

            const response = await fetch(BULK_EQUIPMENT_UPLOAD_URL, {
                method: "POST",
                headers: { Authorization: `Bearer ${accessToken}` },
                body: formData,
            });
            if (!response.ok) {
                let message = `Error ${response.status}`;
                const contentType = response.headers.get("content-type") || "";
                if (contentType.includes("application/json")) {
                    try {
                        const body = await response.json();
                        if (typeof body?.error === "string") message = body.error;
                    } catch {
                        // silently ignore error to use default error message
                    }
                }
                throw new Error(message);
            }
            return response.json();
        },
        onSuccess,
        onError: (error) => {
            showMutationAlert(error, alert);
        },
    });
};

export default useSubmitBulkEquipmentSurveyCsvMutation;
